<app-menu> 

  <!-- UNIVERSAL SEARCH -->
  <form 
    [formGroup]="universal_filter"
    style="display:flex; justify-content:center; align-items:center; gap:10px; margin-bottom:10px"
  >
    <mat-form-field appearance="outline">
      <mat-label>Grid Search</mat-label>
      <input matInput formControlName="filter_query" (keydown.enter)="searchAllFilters()">
    </mat-form-field>

    <button mat-raised-button color="primary" (click)="searchAllFilters()">
      Search Grid
    </button>

    <button mat-raised-button color="primary" (click)="clearFilter()">
      Clear All Filters
    </button>
  </form>

  <!-- MAIN GRID -->
  <ag-grid-angular
    *ngIf="gridReady"
    class="{{ themeClass }}"
    style="width: 100%; height: calc(100vh - 160px);"

    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"

    [gridOptions]="gridOptions"

    [rowModelType]="rowModelType"
    [cacheBlockSize]="cacheBlockSize"
    [cacheOverflowSize]="cacheOverflowSize"
    [maxConcurrentDatasourceRequests]="maxConcurrentDatasourceRequests"
    [infiniteInitialRowCount]="infiniteInitialRowCount"

    [sideBar]="true"
    [getRowId]="getRowId"

    [initialState]="initialState"

    [masterDetail]="true"
    [detailCellRenderer]="detailCellRenderer"
    [detailRowHeight]="500"

    [context]="context"

    (gridReady)="onGridReady($event)"
    (stateUpdated)="onStateUpdated($event)"
    (rowEditingStopped)="onRowEditingStopped($event)"
  >
  </ag-grid-angular>

</app-menu>
